import { render, staticRenderFns } from "./BetaOnlyNotice.vue?vue&type=template&id=28e122ff&scoped=true&"
import script from "./BetaOnlyNotice.vue?vue&type=script&lang=ts&"
export * from "./BetaOnlyNotice.vue?vue&type=script&lang=ts&"
import style0 from "./BetaOnlyNotice.vue?vue&type=style&index=0&id=28e122ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e122ff",
  null
  
)

export default component.exports